import { render, staticRenderFns } from "./mbUsers.vue?vue&type=template&id=0eb3a026"
import script from "./mbUsers.vue?vue&type=script&lang=js"
export * from "./mbUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports